export const COLOR_MODE_KEY = 'asl-color-mode';
export const QUERY_COLOR_MODE_KEY = 'theme';
